import {Inject, Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {DOCUMENT} from '@angular/common';
import {LinkDefinition} from '../classes/app.models';


@Injectable({
    providedIn: 'root',
})
export class SEOService {
    constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc) {
    }

    //
    // createLinkForCanonicalURL(data: string) {
    //     if (data === undefined) {
    //     } else {
    //         let link: HTMLLinkElement = this.doc.createElement('link');
    //         link.setAttribute('rel', 'canonical');
    //         this.doc.head.appendChild(link);
    //         link.setAttribute('href', this.doc.URL);
    //     }
    // }

    updateCanonicalUrl(url: string) {
        const head = this.doc.getElementsByTagName('head')[0];
        let element: HTMLLinkElement = this.doc.querySelector(`link[rel='canonical']`) || null
        if (element == null) {
            element = this.doc.createElement('link') as HTMLLinkElement;
            head.appendChild(element);
        }
        element.setAttribute('rel', 'canonical')
        element.setAttribute('href', url);
    }

    removeCanonicalUrl()
    {
        const head = this.doc.getElementsByTagName('head')[0];
        let element: HTMLLinkElement = this.doc.querySelector(`link[rel='canonical']`) || null
        if (element != null) {
            element.remove();
        }
    }

    private _parseSelector(tag: LinkDefinition): string {
        // Possibly re-work this
        const attr: string = tag.rel ? 'rel' : 'hreflang';
        return `${attr}="${tag[attr]}"`;
    }


    updateTitle(title: string) {
        if (title) {
            this.title.setTitle(title);
        } else {
            this.title.setTitle('Indiapicture');
        }
    }

    updateOgUrl(url: string) {
        this.meta.updateTag({name: 'og:url', content: url});
    }

    updateData(name: string, data: string) {
        if (data === undefined) {
            this.meta.updateTag({name, content: ''});
        } else {
            this.meta.updateTag({name, content: data});
        }
    }
}
